export default "__VITE_ASSET__Ctkpghm3__"